<script setup lang="ts">
const data = inject(keys.packetVariantCard)
</script>

<template>
  <VariantDescription
    :variant="data?.primary"
    class="flex flex-col gap-legacy-s md:gap-legacy-m"
  />
</template>
